/* Presentation enhancements only. Cornerstone owns all commerce and variant logic. */
(() => {
  if (window.anyiThemeReady) return;
  window.anyiThemeReady = true;
  const selected = new Map();
  const one = (s, root = document) => root.querySelector(s);
  const all = (s, root = document) => [...root.querySelectorAll(s)];
  let lastDialogTrigger;
  let timer;
  function showToast(message) {
    const el = one('[data-anyi-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(() => { el.hidden = true; }, 3000);
  }
  function syncCompare() {
    all('[data-anyi-compare]').forEach(b => {
      const checked = selected.has(b.dataset.id);
      b.setAttribute('aria-pressed', String(checked));
      b.textContent = checked ? '✓ Selected' : '+ Compare';
    });
    const bar = one('[data-anyi-compare-bar]');
    if (!bar) return;
    bar.hidden = !selected.size;
    one('[data-anyi-compare-count]').textContent = `${selected.size} of 3 models selected`;
    one('[data-anyi-open-compare]').disabled = selected.size < 2;
  }
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    lastDialogTrigger = trigger;
    if (!dialog.open) dialog.showModal();
    return true;
  }
  function closeDialog(dialog) {
    dialog?.close();
    lastDialogTrigger?.focus();
  }
  function activateTab(button, focus = false) {
    const root = button.closest('[data-anyi-tabs]');
    all('[data-anyi-tab]', root).forEach(b => {
      const active = b === button;
      b.setAttribute('aria-selected', String(active));
      b.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(b.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) button.focus();
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button, a[data-anyi-finder]');
    if (!target) return;
    if (target.matches('[data-anyi-tab]')) activateTab(target);
    if (target.matches('[data-anyi-finder]') && openDialog('AnyiFinder', target)) event.preventDefault();
    if (target.matches('[data-anyi-close]')) closeDialog(target.closest('dialog'));
    if (target.matches('[data-anyi-clear]')) { selected.clear(); syncCompare(); }
    if (target.matches('[data-anyi-compare]')) {
      const id = target.dataset.id;
      if (selected.has(id)) selected.delete(id);
      else if (selected.size < 3) selected.set(id, { ...target.dataset });
      else showToast('Compare up to three models at a time.');
      syncCompare();
    }
    if (target.matches('[data-anyi-open-compare]')) {
      const grid = one('[data-anyi-compare-results]');
      grid.replaceChildren();
      selected.forEach(p => {
        const card = document.createElement('article');
        if (p.image) { const img = document.createElement('img'); img.src = p.image; img.alt = p.title; card.append(img); }
        const h = document.createElement('h3'); h.textContent = p.title;
        const price = document.createElement('p'); price.textContent = 'From ' + p.price;
        const link = document.createElement('a'); link.href = p.url; link.className = 'anyi-link'; link.textContent = 'Explore model ↗';
        card.append(h, price, link); grid.append(card);
      });
      openDialog('AnyiCompare', target);
    }
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-anyi-tab]');
    if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = all('[data-anyi-tab]', button.closest('[data-anyi-tabs]'));
    let index = tabs.indexOf(button);
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = tabs.length - 1;
    event.preventDefault(); activateTab(tabs[index], true);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-anyi-plan-check]')) return;
    const planner = event.target.closest('.anyi-planner');
    const count = all('[data-anyi-plan-check]:checked', planner).length;
    one('[data-anyi-progress]', planner).textContent = `${count} of 4 planning items reviewed`;
    one('progress', planner).value = count;
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-anyi-finder-form]')) return;
    event.preventDefault();
    const input = new FormData(event.target);
    const budget = Number(input.get('budget'));
    const result = one('[data-anyi-finder-results]');
    result.replaceChildren();
    const matches = all('[data-anyi-model]').filter(el => el.dataset.setting === input.get('setting') && el.dataset.available === 'true' && (!budget || Number(el.dataset.price) <= budget));
    const heading = document.createElement('h3');
    heading.textContent = matches.length ? 'Your matching models.' : 'No matching models in this selection.';
    result.append(heading);
    matches.forEach(el => {
      const row = document.createElement('p');
      const a = document.createElement('a'); a.href = el.dataset.url; a.textContent = el.dataset.title + ' ↗';
      const price = document.createElement('span'); price.textContent = 'From ' + el.dataset.money;
      row.append(a, price); result.append(row);
    });
    if (!matches.length) {
      const a = document.createElement('a');
      a.href = (window.Shopify?.routes?.root || '/') + 'collections/all';
      a.textContent = 'Explore the full collection ↗'; result.append(a);
    }
  });
  document.addEventListener('shopify:section:load', syncCompare);
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('.anyi-tab-panel');
    if (panel) {
      const button = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (button) activateTab(button);
    }
  });
  all('.anyi-dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('cancel', () => lastDialogTrigger?.focus());
  });
  syncCompare();
})();

/* BF10 is display/copy only; Shopify Discounts controls checkout eligibility. */
(() => {
 const expire = () => document.querySelectorAll('[data-anyi-bf10]').forEach(el => {
   el.hidden = Date.now() >= Date.parse(el.dataset.end);
 });
 expire(); setInterval(expire, 30000);
 document.addEventListener('shopify:section:load', expire);
 document.addEventListener('visibilitychange', expire);
 document.addEventListener('click', async event => {
   const button=event.target.closest('[data-anyi-copy-bf10]');
   if(!button)return;
   const offer=button.closest('[data-anyi-bf10]');
   if(Date.now()>=Date.parse(offer.dataset.end)){expire();return}
   const status=offer.querySelector('[data-anyi-copy-status]');
   try {await navigator.clipboard.writeText('BF10');status.textContent='Copied! Enter BF10 at checkout.'}
   catch {status.textContent='Enter BF10 manually at checkout.'}
 });
})();
